import axios, { AxiosResponse } from "axios";
import { ExaminerQuality } from "../../models/taskGroup.types";
import EnvWindow from "../../utils/env";


export const getExaminerQuality = async (
  assessmentSessionId: string,
  examinerId: string
): Promise<AxiosResponse<ExaminerQuality>> => {
  return await axios.get(`${EnvWindow.REACT_APP_EVALUATION_API_URL__EXAMINER_QUALITY_API_URL}/AssessmentSessionId/${assessmentSessionId}/ExaminerId/${examinerId}/Quality`);
};
